const INDEX_ITEMS = [
  { title: '娱乐圈最新爆料合集', count: '28篇', tag: '热门' },
  { title: '综艺节目精彩片段汇总', count: '35篇', tag: '精选' },
  { title: '社会热点事件全记录', count: '22篇', tag: '追踪' },
  { title: '明星八卦深度扒皮', count: '41篇', tag: '火爆' },
  { title: '51cg吃瓜直播精彩时刻', count: '19篇', tag: '直播' },
  { title: '年度热门话题排行榜', count: '15篇', tag: '榜单' },
  { title: '网络热门事件解读', count: '33篇', tag: '深度' },
];

const FAQ_ITEMS = [
  {
    q: '51吃瓜网在线观看需要注册吗？',
    a: '51吃瓜网在线观看支持免注册浏览，用户无需登录即可观看大部分吃瓜在线视频内容。如需收藏、评论等个性化功能，可选择注册账号获得更完整的使用体验。',
  },
  {
    q: '51cg吃瓜直播画质如何？',
    a: '51cg吃瓜直播采用高清编码技术，支持自适应码率，根据您的网络状况自动匹配最佳清晰度，无论是在WiFi还是移动网络下都能流畅观看。',
  },
  {
    q: '51吃瓜视频在线支持哪些设备？',
    a: '51吃瓜视频在线全面支持电脑、平板和手机端观看，兼容主流浏览器（Chrome、Safari、Edge等），同时提供iOS和Android移动客户端下载。',
  },
  {
    q: '51吃瓜影视免费观看的内容更新频率？',
    a: '51吃瓜影视免费观看内容每日更新，平台编辑团队全天候追踪热点事件，第一时间上线最新吃瓜在线视频资源，确保用户不错过任何热门内容。',
  },
  {
    q: '如何联系51吃瓜网投稿或合作？',
    a: '您可以通过"联系我们"板块发送邮件，商务合作和内容投稿均在工作日9:00-18:00处理。我们欢迎优质的吃瓜素材和合作伙伴加入51吃瓜网在线观看平台。',
  },
];

const RANKING_ITEMS = [
  { rank: 1, title: '年度最劲爆娱乐圈八卦事件', heat: '128万', trend: 'up' },
  { rank: 2, title: '热门综艺节目名场面盘点', heat: '96万', trend: 'up' },
  { rank: 3, title: '51吃瓜影视免费热门推荐', heat: '85万', trend: 'up' },
  { rank: 4, title: '社会热点深度调查报道', heat: '73万', trend: 'stable' },
  { rank: 5, title: '网红圈最新爆料合集', heat: '68万', trend: 'down' },
  { rank: 6, title: '51cg吃瓜直播人气主播', heat: '59万', trend: 'up' },
  { rank: 7, title: '吃瓜在线视频播放量周榜', heat: '52万', trend: 'stable' },
];

export default function IndexFaqRanking() {
  return (
    <>
      {/* #index - 7 topic index items */}
      <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              内容索引
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              51吃瓜网在线观看全部专题内容分类导航
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {INDEX_ITEMS.map((item) => (
              <div
                key={item.title}
                className="flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
              >
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                  <i className="ri-folder-line text-lg"></i>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap flex-shrink-0">{item.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.count}</span>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #faq - 5 expanded FAQs */}
      <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              关于51吃瓜网在线观看的常见疑问解答
            </p>
          </div>
          <div className="space-y-3">
            {FAQ_ITEMS.map((item, idx) => (
              <div
                key={idx}
                className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
              >
                <div className="p-4 md:p-5 flex items-start gap-3">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <span className="text-sm font-bold">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">{item.q}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #ranking - 7 ranking items */}
      <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              热门内容排行
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              51吃瓜网在线观看本周最受欢迎的内容榜单
            </p>
          </div>
          <div className="space-y-2">
            {RANKING_ITEMS.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
              >
                {/* Rank number */}
                <div
                  className={`w-8 h-8 md:w-9 md:h-9 flex-shrink-0 flex items-center justify-center rounded-lg text-sm font-bold ${
                    item.rank === 1
                      ? 'bg-primary-500 text-white'
                      : item.rank === 2
                      ? 'bg-accent-500 text-white'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-white'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>
                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                </div>
                {/* Heat */}
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs text-foreground-400">
                    <i className="ri-eye-line mr-0.5"></i>{item.heat}
                  </span>
                  <span className={`text-xs ${
                    item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-foreground-400' : 'text-accent-500'
                  }`}>
                    {item.trend === 'up' && <i className="ri-arrow-up-line"></i>}
                    {item.trend === 'down' && <i className="ri-arrow-down-line"></i>}
                    {item.trend === 'stable' && <i className="ri-arrow-right-line"></i>}
                  </span>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}